<template>
  <el-dialog :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false">
    <el-form :label-position="labelPosition" ref="ChangePasswordForm" :rules="rule" label-width="80px"
             :model="changePasswordForm">
      <div style="background: #FFFFFF;text-align: center">
        <em class="el-icon-close dialog-close-manual" v-on:click="dialogFormVisible = false"></em>
        <h1 style="width: 100%;height: 30px;line-height: 30px;font-size: 16px;color: #000000;padding: 15px;">
          修改密码</h1>
        <div style="width: 50%;margin: auto;position: relative;padding-bottom: 60px">
          <el-form-item label="原密码" prop="beforePassword">
            <el-input v-model="changePasswordForm.beforePassword"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="afterPassword">
            <el-input v-model="changePasswordForm.afterPassword"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPwd">
            <el-input v-model="confirmPwd"></el-input>
          </el-form-item>
          <el-button style="position: absolute;right: 0" v-on:click="doChangePassword">提交</el-button>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>

import store from "@/components/dataStore";
import AxiosBase from "@/components/axiosBase";
import {Message} from "element-ui";
import util from "@/components/util";

export default {
  name: "ChangePassword",
  store,
  data() {
    const validateAfterPassword = (rule, value, callback) => {
      if (this.confirmPwd === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (this.confirmPwd === this.changePasswordForm.beforePassword) {
          callback(new Error('新密码不可以与原密码相同'));
        } else {
          if (this.confirmPwd.length < 8 || this.confirmPwd.length > 256) {
            callback(new Error("请输入正确长度的密码[8-256]"))
          }
        }
        callback();
      }
    }
    const validateConfirmPwd = (rule, value, callback) => {
      if (this.confirmPwd === '') {
        callback(new Error('请再次输入密码'))
      } else {
        if (this.confirmPwd !== this.changePasswordForm.afterPassword) {
          callback(new Error('两次输入的密码不同'));
        }
        callback();
      }
    }
    return {
      labelPosition: 'top',
      dialogFormVisible: false,
      changePasswordForm: {
        beforePassword: '',
        afterPassword: ''
      },
      confirmPwd: '',
      rule: {
        beforePassword: [
          {required: true, message: '请输入原密码', trigger: 'blur'},
          {min: 8, max: 256, message: '请输入正确长度的原密码', trigger: 'blur'}
        ],
        afterPassword: [
          {validator: validateAfterPassword, trigger: 'blur'}
        ],
        confirmPwd: [
          {validator: validateConfirmPwd, trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    doChangePassword() {
      this.$refs['ChangePasswordForm'].validate((valid) => {
        if (valid) {
          this.changePasswordForm.beforePassword = util.MD5(this.changePasswordForm.beforePassword);
          this.changePasswordForm.afterPassword = util.MD5(this.changePasswordForm.afterPassword)
          AxiosBase.axiosPost("/user/change-password", this.changePasswordForm).then(response => {
            if (response !== 0) {
              this.dialogFormVisible = false;
              Message({
                showClose: true,
                message: '密码修改成功',
                type: 'success'
              });
            }
          })
        }
      });
    }
  }
}
</script>

